module.exports = __webpack_public_path__ + "files/d5a585ef11e29165135c4e9a4f4e8d30.png";